<template>
<div class="form-group d-inline-flex w-100">
    <label class="input-label mr-3 w-25">Tutorial Icon</label>
    <select 
        name="tutorial[icon]" 
        class="form-control selectpicker w-50" 
        v-model="currentIcon">
        <option 
            v-for="icon in icons"
            :key="icon.id"
            :selected = "icon.id === currentIcon" 
            :value="icon.id"
            >
            {{ icon.name }}
        </option>
    </select>
    <div class="w-25 pl-4">
        <img class="image-fluid h-75" 
        :src="getCurrentIcon">
    </div>
</div>
</template>

<script>
export default {
    props: {
        icons: {
            type: Array,
            default: []
        },
        selectedIcon: {
            type: String,
        }
    },

    data() {
        return {
            currentIcon: 1
        }
    },

    created() {
        this.setCurrentIcon();
    },

    computed: {
        getCurrentIcon() {
            let icon = this.icons.find(icon => icon.id === this.currentIcon);
            return icon.icon_path;
        }
    },

    methods: {
        setCurrentIcon() {
            if(this.getIconFromRecord()) {
                let tutorialIcon = this.icons.find(icon => icon.icon === this.selectedIcon);
                this.currentIcon = tutorialIcon.id; 
            }
            else if(this.getIconAfterError()){
                this.currentIcon = parseInt(this.selectedIcon); 
            }
        },

        getIconFromRecord() {
            return this.selectedIcon && this.isStringProp(this.selectedIcon)
        },

        getIconAfterError() {
            return this.selectedIcon && !this.isStringProp(this.selectedIcon)
        },

        isStringProp(propValue) {
            return isNaN(parseInt(propValue));
        }
    }
}    
</script>
